import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    keywords?: string;
    image?: string;
    url?: string;
    type?: string;
}

const SEO: React.FC<SEOProps> = ({
    title = "devNectar - Complete Software Development & Support",
    description = "Expert software development and support services including web development, mobile apps, AI solutions, and cloud infrastructure.",
    keywords = "Software Development, SharePoint, Power Platform, React, Node.js, Cloud Solutions, AI/ML, DevOps",
    image = "/devNectar4.png",
    url = "https://devnectar.in",
    type = "website"
}) => {
    const siteTitle = title.includes("devNectar") ? title : `${title} | devNectar`;

    return (
        <Helmet>
            {/* Standard Metadata */}
            <title>{siteTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <link rel="canonical" href={url} />

            {/* Open Graph Tags */}
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />

            {/* Twitter Card Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={siteTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;
